import { Box, ButtonGroup, Flex, BoxProps } from '@chakra-ui/react';

interface IFingerWithButtons extends BoxProps {
  children: React.ReactNode;
  actions?: React.ReactNode;
}

export const FingerWithButtons = (props: IFingerWithButtons) => {
  const { children, actions } = props;
  return (
    <Flex
      py={2}
      pl={{ base: 1, xl: 3 }}
      pr={{ base: 2, xl: 4 }}
      columnGap={{ base: 2, xl: 4 }}
      bgColor={'chakra-body-bg'}
      borderTopWidth={2}
      {...props}
    >
      <Box flexGrow={1}>{children}</Box>

      {actions && (
        <ButtonGroup flexShrink={0} spacing={1}>
          {actions}
        </ButtonGroup>
      )}
    </Flex>
  );
};
